/* tslint:disable */
/* eslint-disable */
/**
 * Riders API
 * Internal Riders TV API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetRiderLocations200ResponseInner
 */
export interface GetRiderLocations200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetRiderLocations200ResponseInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetRiderLocations200ResponseInner
     */
    name: string;
}

/**
 * Check if a given object implements the GetRiderLocations200ResponseInner interface.
 */
export function instanceOfGetRiderLocations200ResponseInner(value: object): value is GetRiderLocations200ResponseInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function GetRiderLocations200ResponseInnerFromJSON(json: any): GetRiderLocations200ResponseInner {
    return GetRiderLocations200ResponseInnerFromJSONTyped(json, false);
}

export function GetRiderLocations200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRiderLocations200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function GetRiderLocations200ResponseInnerToJSON(json: any): GetRiderLocations200ResponseInner {
    return GetRiderLocations200ResponseInnerToJSONTyped(json, false);
}

export function GetRiderLocations200ResponseInnerToJSONTyped(value?: GetRiderLocations200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

